import { render, staticRenderFns } from "./membership-category-card.vue?vue&type=template&id=5de3f449&scoped=true&"
import script from "./membership-category-card.vue?vue&type=script&lang=ts&"
export * from "./membership-category-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de3f449",
  null
  
)

export default component.exports